<template>
    <div class="sys-main-warpper">
        <div class="brands-wrapper">
            <ChannelTree v-if="treeDataList.length > 0" :treeData="treeDataList" @clickSide="clickSide"
                :checkMaps="playCameraNo">
            </ChannelTree>
        </div>
        <div class="role-container">
            <div style="margin-bottom: 20px;">
                <span :class="activeTab === 1 ? 'span active' : 'span'" @click="handleTabClick(1, 24, 1)">1</span>
                <span :class="activeTab === 4 ? 'span active' : 'span'" @click="handleTabClick(4, 12, 2)">4</span>
                <span :class="activeTab === 9 ? 'span active' : 'span'" @click="handleTabClick(9, 8, 3)">9</span>
            </div>

            <el-row :gutter="10" style="height: 100%;" id="elRowHeight">
                <el-col v-for="(n, index) in activeTab" :xs="24" :sm="24" :md="clonum" :lg="clonum" :xl="clonum"
                    :key="index">
                    <div class="player-wrapper" @click.stop="checkedWindow(index)"
                        :style="checkedIndex === index ? 'border: 1px solid red;' + cssStyle : cssStyle">
                        <template v-if="videoList[index] && videoList[index].url">
                            <VideoPlayer :videoUrl="videoList[index].url" :isLive="true"
                                :ref="'videoPlayerRef_' + index" :videoPlayerRef="'videoPlayerRef_' + index">
                            </VideoPlayer>
                            <div class="player-close" @click.stop="closeVideo(index)">X</div>
                            <div class="player-channelName">{{
                $t('reportCenter.videoEn.channelName') }}：{{ videoList[index].channelName }}</div>
                        </template>

                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import ChannelTree from "./components/channelTree.vue";
import VideoPlayer from "@/components/videoPlayer.vue";

import Cookies from "js-cookie";
export default {
    components: {
        ChannelTree,
        VideoPlayer
    },
    data() {
        return {
            monitorId: Number(Cookies.get("monitorId")),
            cameraNo: null,
            treeDataList: [],
            tableData: [],
            activeTab: 4,
            clonum: 12,
            cssStyle: '',
            checkedIndex: 0,
            videoList: new Array(9),
            maps: new Map(),
            playCameraNo: [],
        }
    },
    created() {

    },
    mounted() {
        this.getTreeList();
        this.cssStyle = 'height:' + ((document.body.clientHeight - 230) / 2) + 'px;'
    },
    methods: {
        setPlayCameraNo() {
            let list = [];
            this.maps.forEach((val, key) => {
                if (val) {
                    list.push(key);
                }
            })
            this.playCameraNo = list;
        },
        closeVideo(index) {
            this.$refs['videoPlayerRef_' + index][0].videoDestory();
            this.maps.set(this.videoList[index].cameraNo, false);
            this.setPlayCameraNo();
            this.videoList[index] = {};
            this.videoList = JSON.parse(JSON.stringify(this.videoList));
        },
        checkedWindow(index) {
            this.checkedIndex = index;
        },
        handleTabClick(index, clonum, row) {
            if (this.checkedIndex > index) {
                this.checkedIndex = 0;
            }
            let list = new Array(9);
            this.videoList.forEach((item, i) => {
                if (i < index) {
                    list[i] = item;
                } else {
                    if (item && item.url) {
                        this.closeVideo(i);
                    }
                }
            });
            this.activeTab = index;
            this.clonum = clonum;
            this.cssStyle = 'height:' + ((document.body.clientHeight - 230) / row) + 'px;'
            this.videoList = list;
            this.videoList = JSON.parse(JSON.stringify(this.videoList));
        },
        clickSide(cameraNo, name) {
            if (this.maps.get(cameraNo)) {
                return false;
            }

            if (this.videoList[this.checkedIndex] && this.videoList[this.checkedIndex].cameraNo) {
                this.closeVideo(this.checkedIndex);
            }

            this.videoList[this.checkedIndex] = {
                cameraNo,
                channelName: name,
                url: window.baseURL + this.$Api.imageStream + '/' + this.monitorId + '/' + cameraNo
            }
            this.maps.set(cameraNo, this.maps.get(cameraNo) ? false : true);
            this.setPlayCameraNo();
            this.videoList = JSON.parse(JSON.stringify(this.videoList));
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
        },
        async getTreeList() {
            let res = await this.$Http.get(this.$Api.userTree + '/' + this.monitorId);
            if (res.result && res.result.length > 0) {
                this.treeDataList = res.result;
            }
        },
    },
}
</script>

<style scoped lang="scss">
.sys-main-warpper {
    display: flex;
    width: 100%;

    .brands-wrapper {
        margin-right: 20px;
        flex: 0 0 245px;
        width: 245px;
        flex-shrink: 0;
    }

    .role-container {
        display: flex;
        flex-direction: column;
        width: calc(100% - 245px - 20px);
    }
}

.span {
    display: inline-block;
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 2px;
    border: 1px solid #979797;
    font-size: 18px;
    color: #5B647D;
    margin-right: 10px;
    cursor: pointer;
    text-align: center;
}

.span:first-child {
    margin-left: 30px;
}

.span.active {
    background: #0B73F6;
    color: #fff;
}

.player-wrapper {
    position: relative;
    margin-bottom: 10px;
    background: #5B647D;
    cursor: pointer;
}

.player-wrapper:hover>.player-close {
    display: block;
}

.player-close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: none;
}

.player-channelName {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 36px;
    line-height: 36px;
    padding: 0 10px;
    background: #010101;
    opacity: 0.63;
    color: #fff;
    font-size: 13px;
}
</style>